<div class="container-fluid g-0 m-0">
  <div class="row g-0 m-0 d-flex pt-5 align-items-center">
    <div class="col-md-1 d-flex pe-4 justify-content-end">
      <div class="button-back pb-3" [routerLink]="['/settings/team/members']">
        <svg-icon alt="Back" src="assets/core/back-button.svg"></svg-icon>
      </div>
    </div>
    <div class="col-md-11">
      @if (memberId) {
        <h2 class="col pb-2 m-0 title">
          {{ "EDITMEMBER" | translate }}
        </h2>
      } @else {
        <h2 class="col pb-2 m-0 title">
          {{ "SETTINGS_TEAMSETUP" | translate }}
        </h2>
      }
      <p class="col subtitle">
        {{ "SETTINGS_TEAMSETUP_SUBTITLE" | translate }}
      </p>
    </div>
  </div>
  <form #crudform="ngForm" (ngSubmit)="onSubmit()">
    <div class="form-item">
      <label class="form-label" for="firstName">{{
        "FIRSTNAME" | translate
      }}</label>
      <div class="form-input">
        <input
          id="firstName"
          [(ngModel)]="data.firstName"
          #firstName="ngModel"
          name="firstName"
          type="text"
          required
        />
        @if (crudform.submitted && firstName.invalid) {
          <div class="validation-error">
            {{ "FIRSTNAME" | translate
            }}{{ "DEVICESETUP_ISREQUIRED" | translate }}
          </div>
        } @else if (!firstName.valid) {
          <div class="validation-instruction">
            {{ "TEAMSETUP_FIRSTNAMEDESC" | translate }}
          </div>
        }
      </div>
    </div>
    <div class="form-item">
      <label class="form-label" for="middleName">{{
        "MIDDLENAME" | translate
      }}</label>
      <div class="form-input">
        <input
          id="middleName"
          [(ngModel)]="data.middleName"
          #middleName="ngModel"
          name="middleName"
          type="text"
        />
        @if (crudform.submitted && middleName.invalid) {
          <div class="validation-error">
            {{ "MIDDLENAME" | translate
            }}{{ "DEVICESETUP_ISREQUIRED" | translate }}
          </div>
        } @else if (middleName.value == null || middleName.value === "") {
          <div class="validation-instruction">
            {{ "TEAMSETUP_MIDDLENAMEDESC" | translate }}
          </div>
        }
      </div>
    </div>
    <div class="form-item">
      <label class="form-label" for="lastName">{{
        "LASTNAME" | translate
      }}</label>
      <div class="form-input">
        <input
          id="lastName"
          [(ngModel)]="data.lastName"
          #lastName="ngModel"
          name="lastName"
          type="text"
          required
        />
        @if (crudform.submitted && lastName.invalid) {
          <div class="validation-error">
            {{ "LASTNAME" | translate
            }}{{ "DEVICESETUP_ISREQUIRED" | translate }}
          </div>
        } @else if (!lastName.valid) {
          <div class="validation-instruction">
            {{ "TEAMSETUP_LASTNAMEDESC" | translate }}
          </div>
        }
      </div>
    </div>
    <div class="form-item">
      <label class="form-label" for="email">{{
        "EMAILADDRESS" | translate
      }}</label>
      <div class="form-input">
        <input
          id="email"
          [(ngModel)]="data.email"
          #email="ngModel"
          name="email"
          type="text"
          pattern="[a-zA-Z0-9._%+\-]+@[a-zA-Z0-9.\-]+\.[a-zA-Z]{2,}"
          required
        />
        @if (crudform.submitted && email.invalid) {
          <div class="validation-error">
            {{ "EMAIL" | translate }}{{ "DEVICESETUP_ISREQUIRED" | translate }}
          </div>
        }
        @if (!data.email || data.email.trim() === "") {
          <div class="validation-instruction">
            {{ "TEAMSETUP_EMAILADDRESSDESC" | translate }}
          </div>
        } @else if (
          email.invalid && email.touched && email.errors?.["pattern"]
        ) {
          <div class="validation-error">
            {{ "TEAMSETUP_EMAILADDRESSERROR" | translate }}
          </div>
        }
      </div>
    </div>
    <div class="form-item">
      <label class="form-label" for="phoneNumber">{{
        "PHONENUMBER" | translate
      }}</label>
      <div class="form-input">
        <input
          id="phoneNumber"
          [(ngModel)]="data.phoneNumber"
          #phoneNumber="ngModel"
          name="phoneNumber"
          type="text"
          pattern="^\+?[0-9]+$"
        />
        @if (crudform.submitted && phoneNumber.invalid) {
          <div class="validation-error">
            {{ "PHONENUMBER" | translate
            }}{{ "DEVICESETUP_ISREQUIRED" | translate }}
          </div>
        }
        @if (!data.phoneNumber || data.phoneNumber.trim() === "") {
          <div class="validation-instruction">
            {{ "TEAMSETUP_PHONENUMBERDESC" | translate }}
          </div>
        } @else if (
          phoneNumber.invalid &&
          phoneNumber.touched &&
          phoneNumber.errors?.["pattern"]
        ) {
          <div class="validation-error">
            {{ "TEAMSETUP_PHONENUMBERERROR" | translate }}
          </div>
        }
      </div>
    </div>
    <div class="form-item">
      <label class="form-label" for="address">{{
        "DEVICESETUP_DEVICEADDRESS" | translate
      }}</label>
      <div class="form-input">
        <input
          id="address"
          [(ngModel)]="data.address"
          #address="ngModel"
          name="address"
          type="text"
        />
        @if (crudform.submitted && address.invalid) {
          <div class="validation-error">
            {{ "DEVICESETUP_DEVICEADDRESS" | translate
            }}{{ "DEVICESETUP_ISREQUIRED" | translate }}
          </div>
        }
        @if (!data.address || data.address.trim() === "") {
          <div class="validation-instruction">
            {{ "ADDRESSDESC" | translate }}
          </div>
        }
      </div>
    </div>
    <div class="horizontal-line"></div>
    <div class="form-item">
      <label class="form-label" for="role">{{ "ROLE" | translate }}</label>
      <div class="form-input">
        <select
          id="role"
          [(ngModel)]="data.roleId"
          name="role"
          (ngModelChange)="updateRoleId($event)"
          #role="ngModel"
          required
        >
          <option *ngFor="let role of roles" [ngValue]="role.id">
            {{ role.name }}
            @if (role.status != userStatus.Active){
              ({{ role.status }})
            }
          </option>
        </select>
        @if (role.value == null || role.value === "") {
          <div class="validation-instruction">
            {{ "TEAMSETUP_ROLEDESC" | translate }}
          </div>
        }
      </div>
    </div>

    <div class="horizontal-line"></div>
    <div class="form-item">
      <label class="form-label">{{ "ALL_REGIONS" | translate }}</label>
      <div class="form-input">
        <label class="switch-container me-3">
          <label class="switch">
            <input
              [(ngModel)]="allRegions"
              name="allRegions"
              (ngModelChange)="onAllRegionsChange()"
              type="checkbox"
            />
            <span class="slider"></span>
          </label>
        </label>
      </div>
    </div>

    <div class="horizontal-line" *ngIf="!allRegions"></div>
    <div class="form-item" *ngIf="!allRegions">
      <label class="form-label" for="region">{{
        "DEVICESETUP_REGION" | translate
      }}</label>
      <div class="form-input">
        <ng-select
          id="region"
          [items]="regions"
          bindLabel="name"
          bindValue="value"
          [(ngModel)]="tempRegion"
          name="region"
          #region="ngModel"
          (ngModelChange)="selectedRegion($event)"
          [multiple]="false"
          [searchable]="false"
          [clearable]="false"
          [required]="selectedRegions.length === 0"
        ></ng-select>

        <div class="row-md-12 selected-container custom-margins mt-3 d-flex flex-wrap gap-3" *ngIf="selectedRegions.length > 0">
          <div *ngFor="let reg of selectedRegions" class="selected ps-3 pt-2 pb-2 pe-3 d-flex justify-content-center">
            <span class="pe-2">{{ reg.name }}</span>
            <img
              alt="Remove Region"
              (click)="removeRegion(reg)"
              src="assets/core/filter/filter-x.svg"
            />
          </div>
        </div>

        @if (selectedRegions.length === 0) {
          <div class="validation-instruction">
            {{ "TEAMSETUP_REGIONDESC" | translate }}
          </div>
        }
      </div>
    </div>

    <div class="form-item" *ngIf="!allRegions">
      <label class="form-label" for="district">{{
        "DISTRICT" | translate
      }}</label>
      <div class="form-input">
        <ng-select
          id="district"
          [items]="areas"
          bindLabel="name"
          bindValue="value"
          [(ngModel)]="tempDistrict"
          name="district"
          #district="ngModel"
          (ngModelChange)="selectedDistrict($event)"
          [multiple]="false"
          [searchable]="false"
          [clearable]="false"
          [required]="selectedDistricts.length === 0"
        ></ng-select>

        @if (selectedDistricts && !edit) {
          <div
            class="row-md-12 selected-container custom-margins mt-3 d-flex flex-wrap gap-3"
          >
            <div
              *ngFor="let area of selectedDistricts"
              class="selected ps-3 pt-2 pb-2 pe-3 d-flex justify-content-center"
            >
              <span class="pe-2">{{ area.name }}</span>
              <img
              alt="Remove Area"
                (click)="removeDistrict(area)"
                src="assets/core/filter/filter-x.svg"
              />
            </div>
          </div>
        }
        @if (edit) {
          <div
            class="row-md-12 selected-container custom-margins mt-3 d-flex flex-wrap gap-3"
          >
            <div
              *ngFor="let area of editAreas"
              class="selected ps-3 pt-2 pb-2 pe-3 d-flex justify-content-center"
            >
              <span class="pe-2">{{ area.name }}</span>
              <img
              alt="Remove Area"
                (click)="removeDistrict(area)"
                src="assets/core/filter/filter-x.svg"
              />
            </div>
          </div>
        }
      </div>
    </div>

    <div class="form-item-button">
      <button class="button-submit" [disabled]="crudform.invalid" type="submit">
        {{ "CONTINUE" | translate }}
      </button>
      <div [routerLink]="['/settings/team/members']">
        <button class="button-cancel" type="button">
          {{ "CANCEL" | translate }}
        </button>
      </div>
    </div>
  </form>
</div>
